import { MedicalNotePinOption } from "@/Common/Models/Employee/Enums/MedicalNotePinOption";

interface NoteActionConfig {
    id: MedicalNotePinOption;
    labelKey: string;
}

class StreamlineNoteCompletionHelper {
    public static getNoteActionConfig(): NoteActionConfig[] {
        return [
            { id: MedicalNotePinOption.ApproveCompleteClose, labelKey: "StreamlineNote_ApproveCloseAndCompleteLabel" },
            { id: MedicalNotePinOption.ApproveComplete, labelKey: "StreamlineNote_ApproveAndCompleteLabel" },
            { id: MedicalNotePinOption.ApproveClose, labelKey: "StreamlineNote_ApproveAndCloseLabel" },
            { id: MedicalNotePinOption.Approve, labelKey: "ApproveLabel" },
            { id: MedicalNotePinOption.SaveCompleteClose, labelKey: "StreamlineNote_SaveCloseAndCompleteLabel" },
            { id: MedicalNotePinOption.SaveComplete, labelKey: "StreamlineNote_SaveAndCompleteLabel" },
            { id: MedicalNotePinOption.SaveClose, labelKey: "StreamlineNote_SaveAndCloseLabel" },
            { id: MedicalNotePinOption.Save, labelKey: "SaveLabel" }
        ];
    }

    public static getReadOnlyOptions(): MedicalNotePinOption[] {
        return [MedicalNotePinOption.Approve, MedicalNotePinOption.ApproveClose, MedicalNotePinOption.ApproveCompleteClose, MedicalNotePinOption.ApproveComplete];
    }
}

export { StreamlineNoteCompletionHelper };
